export default __webpack_public_path__ + "static/media/264.b3c5496a.png";